module.exports = __webpack_public_path__ + "img/img17.6de482f0.svg";